import React from 'react';
import SimpleReportForm from '../SimpleReportForm';
import CAMembershipOutputComponent from '../output/CAMembershipOutputComponent';

const CAMembershipInputComponent = ({ serviceId, serviceDetails, leadId }) => (
    <SimpleReportForm
        serviceId={serviceId}
        serviceDetails={serviceDetails}
        leadId={leadId}
        banner={{ icon: 'pi-graduation-cap', title: 'CA Membership Verification', subtitle: 'Verify Chartered Accountant membership credentials' }}
        fields={[
            { name: 'membership_no', label: 'Membership Number', icon: 'pi-id-card', placeholder: 'e.g. 123456', maxLength: 10, mono: true,
              regex: /^\d{6,8}$/, regexError: 'Enter a valid 6-8 digit membership number', colClass: 'col-12 md:col-6 lg:col-4' },
            { name: 'mobile', label: 'Mobile (optional)', icon: 'pi-phone', placeholder: '9876543210', maxLength: 10, inputMode: 'tel', numeric: true, mono: true, required: false,
              colClass: 'col-12 md:col-6 lg:col-4' },
            { name: 'pan', label: 'PAN (optional)', icon: 'pi-credit-card', placeholder: 'ABCDE1234F', maxLength: 10, autoCapitalize: 'characters', spellCheck: false, uppercase: true, mono: true, required: false,
              colClass: 'col-12 md:col-6 lg:col-4' },
        ]}
        endpoint={{
            path: '/tartan/ca-membership/verify',
            bodyMapper: (v, sid, lid) => ({
                membership_no: v.membership_no,
                pan: v.pan || null,
                mobile: v.mobile || null,
                application_id: 'test',
                api_provider_service_id: parseInt(sid, 10),
                ...(lid ? { lead_id: parseInt(lid, 10) } : {}),
            }),
        }}
        consentReportType="ca-membership"
        submitLabel="Verify Membership"
        successSummary="CA membership verified"
        errorSummary="CA membership verification failed"
        confirmHeader="Confirm CA membership verification"
        confirmAcceptLabel="Yes, verify"
        outputComponent={CAMembershipOutputComponent}
    />
);

export default CAMembershipInputComponent;
